<template>
  <div :class="{ 'top-sticky': isMobile }">
    <template v-if="!isMobile">
      <DesktopCropperHeader type="type" :is-read-only="isReadOnly" :disabled="disabled" :field="field" :current="current" :total="total" @back="$emit('back', $event)" @skip="$emit('skip')" @next="$emit('next', $event)" @help="$emit('help', $event)" />
    </template>
    <template v-else>
      <MobileCropperHeader :type="type" :disabled="disabled" :current="current" :total="total" @back="$emit('back', $event)" @next="$emit('next', $event)" @help="$emit('help', $event)" />
      <MobileCropperSubheader :field="field" @skip="$emit('skip')" />
    </template>
  </div>
</template>
<script>
import DesktopCropperHeader from './DesktopCropperHeader.vue'
import MobileCropperHeader from './MobileCropperHeader.vue'
import MobileCropperSubheader from './MobileCropperSubheader.vue'

export default {
  components: { DesktopCropperHeader, MobileCropperHeader, MobileCropperSubheader },
  props: {
    isReadOnly: { type: Boolean, default: false },
    field: { type: Object, required: true },
    current: { type: Number, default: 1 },
    total: { type: Number, default: 1 },
    disabled: { type: Boolean, default: false },
    type: { type: String, required: true }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    }
  }
}
</script>
<style scoped>
  .top-sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 56px;
    background-color: white;
    z-index: 3;
  }
</style>
